import { useSelector } from 'react-redux'
import { GoToRedirectLink } from './components'

function stages({ ...props }) {
  return {
    initial: <GoToRedirectLink {...props} />,
  }
}

export function RedirectModal() {
  const { stage, data } = useSelector(({ modal }) => modal)

  return stages({ ...data })[stage]
}
